import { useGame } from '../../../data/gameContext';
import { TMapTile, ETerrainTypes } from '../../map/mapTypes';
import '../basePanel.css';
export default function BasePanelLocation(){
    const { gameState, getGameTime, updateGameState } = useGame(); 
      // from gameState.GameMap get the currentLocation of the player based on the players location x and y (which must be integers)
  // get the terrain type from the currentLocation
  const currentLocation: TMapTile = gameState.GameMap[
    Math.round(gameState.PlayerCharacter!.Location.y)
  ][
    Math.round(gameState.PlayerCharacter!.Location.x)
  ];
  const terrainType: ETerrainTypes = currentLocation.Terrain;
  const areWeAtATown: boolean = gameState.GameTowns.some(
    (town) => town.Location.x === gameState.PlayerCharacter!.Location.x && town.Location.y === gameState.PlayerCharacter!.Location.y)

  const skyColors: { [key: string]: string } = {
    dawn: "rgba(255, 183, 76, 0.5)",       // orange-pink
    morning: "rgba(135, 206, 250, 0.3)",    // light blue
    noon: "rgba(135, 206, 235, 0.1)",       // bright blue
    afternoon: "rgba(250, 214, 165, 0.3)",  // golden
    evening: "rgba(255, 140, 0, 0.4)",      // orange
    dusk: "rgba(72, 61, 139, 0.5)",         // indigo
    night: "rgba(25, 25, 112, 0.6)"         // dark blue
  };


  const gameTimeString = getGameTime(); 
  let hour = parseInt(gameTimeString.split(" at ")[1].split(":")[0],10); // extract the time
  let amOrPm = gameTimeString.includes("AM") ? "am" : "pm";  // extract AM or PM

  let timeOfDay: string = "";

  if (amOrPm === "am") {
    if (hour >= 5 && hour < 8) {
      timeOfDay = "dawn";
    } else if (hour >= 8 && hour < 12) {
      timeOfDay = "morning";
    } else {
      timeOfDay = "night";
    }
  } else {
    if (hour >= 12 && hour < 3) {
      timeOfDay = "noon";
    } else if (hour >= 3 && hour < 6) {
      timeOfDay = "afternoon";
    } else if (hour >= 6 && hour < 8) {
      timeOfDay = "evening";
    } else {
      timeOfDay = "night";
    }
  }

    return (
        <div className="basePanel-generic">
        <div
          style={{
            width: 420,
            height: 300,
            position: "relative",
            border: "2px solid black",
            padding: 8,
          }}
        >   
          <img
            src="images/locations/Desert.png"
            alt="oooh"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          {/* Sky overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: skyColors[timeOfDay],
              transition: "background-color 1s ease-in-out"
            }}
          />
          {/* Time label */}
          <div
            style={{
              position: "absolute",
              bottom: 10,
              left: 10,
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              padding: "2px 6px",
              fontSize: "14px",
              borderRadius: "4px"
            }}
          >
            {timeOfDay.toUpperCase()}
          </div>
          <div>
            Going to use different images for different terrains, and towns.  Buttons will go here for any actions, like open town screen.
          </div>
          <div>
            {areWeAtATown && gameState.Phase === 'mapView' && <button onClick={() => updateGameState({ ...gameState, Phase: "townView" })}>Enter Town</button>}
            {gameState.Phase === 'townView' && <button onClick={() => updateGameState({ ...gameState, Phase: "mapView" })}>Leave Town</button>} 
          </div>
        </div>
      </div>
    );
}